import { createSlice } from '@reduxjs/toolkit'
import { createAxiosThunk } from 'utils/reduxUtil'
import api from 'api/axios/foka'

export const fetchKeywordPlannerList = createAxiosThunk(
  'bulk/fetchKeywordPlannerList',
  (noArgs, { getState }) => {
    const { page, size } = getState().bulk.keywordUpload
    return api.bulk.getKeywordPlanner(page, size)
  }
)

export const cancelKeywordPlanner = createAxiosThunk(
  'bulk/cancelKeywordPlanner',
  massiveId => api.bulk.cancelKeywordPlanner(massiveId)
)

export const fetchKeywordPlannerFile = createAxiosThunk(
  'bulk/fetchKeywordPlannerFile',
  massiveId => api.bulk.getKeywordPlannerFile(massiveId)
)

const initialState = {
  isLoading: false,
  content: [],
  totalElements: 0,
  page: 0,
  size: 20,
  disabledCancel: false,
  disabledDownload: false,
}

const keywordUploadSlice = createSlice({
  name: 'bulk/keywordUpload',
  initialState,

  reducers: {
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    reset: () => initialState,
  },

  extraReducers: builder => {
    builder.addCase(fetchKeywordPlannerList.pending, state => {
      state.isLoading = true
    })

    builder.addCase(fetchKeywordPlannerList.rejected, state => {
      state.content = []
      state.totalElements = 0
      state.isLoading = false
    })

    builder.addCase(
      fetchKeywordPlannerList.fulfilled,
      (state, { payload: { data } }) => {
        state.content = data.content
        state.totalElements = data.totalElements
        state.isLoading = false
      }
    )

    builder.addCase(cancelKeywordPlanner.pending, state => {
      state.disabledCancel = true
    })

    builder.addCase(cancelKeywordPlanner.rejected, state => {
      state.disabledCancel = false
    })

    builder.addCase(cancelKeywordPlanner.fulfilled, state => {
      state.disabledCancel = false
    })

    builder.addCase(fetchKeywordPlannerFile.pending, state => {
      state.disabledDownload = true
    })

    builder.addCase(fetchKeywordPlannerFile.rejected, state => {
      state.disabledDownload = false
    })

    builder.addCase(fetchKeywordPlannerFile.fulfilled, state => {
      state.disabledDownload = false
    })
  },
})

const { actions, reducer } = keywordUploadSlice
export const { setPage, reset } = actions
export default reducer
